import React from 'react';

import { ErrorBoundary, PageError } from '@/components/Error';

import ScormCardEditable from './ScormCardEditable';
import ScormCardReadOnly from './ScormCardReadonly';
import { ScormCardContainerProps } from './types';

function ScormCardContainer(props: ScormCardContainerProps) {
  const { editable } = props;

  return (
    <ErrorBoundary fallback={PageError}>
      {editable ? <ScormCardEditable {...props} /> : <ScormCardReadOnly {...props} />}
    </ErrorBoundary>
  );
}

export default ScormCardContainer;
